import { render, staticRenderFns } from "./Seo9.vue?vue&type=template&id=f4cbeea8&scoped=true&"
import script from "./Seo9.vue?vue&type=script&lang=js&"
export * from "./Seo9.vue?vue&type=script&lang=js&"
import style0 from "./Seo9.vue?vue&type=style&index=0&id=f4cbeea8&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f4cbeea8",
  null
  
)

export default component.exports